import {
  convertWorkStatusViaKey,
  createBranch,
  createEmptyShiftObject,
  createPrefTimeArray,
  createUserModelObj,
  getBranchForId,
  getGenderType,
  getTempBranchStatusElement,
  getUserRoleObjectForKey,
  getUserToggleEnabled,
  getUserToggleWithKey,
  noneBranchObject,
  noneShiftObject,
} from "./dataProvider";
import {
  EnumEmployeeShiftState,
  UserModel,
  ShiftPlanEmployee,
  ShiftPlanModel,
  BranchModel,
  EnumUserAcces,
  ShiftModel,
  PreferredTimeModel,
  ShiftLogModel,
  ShiftEmployeeEntries,
  ReportModel,
  TempBranchPendingRequestModel,
  EnumTempBranchRequestStatus,
  TempBranchRequestStatusModel,
  EmployeeScheduleModel,
  EmployeeHistoryModel,
  EmployeeDailyLogModel,
  EnumGenderType,
  BranchReportModel,
  EmployeeReportModel,
} from "./dataStructures";
import {
  deleteData,
  fetchData,
  postData,
  updateData,
  uploadImage,
} from "./downloadManager";
import {
  calculateEmployeeBreakTime,
  calculateEmployeeEarning,
  calculateEmployeeElapsedTime,
  calculateTotalIntervalInSeconds,
} from "./processManager";
import {
  getAuthToken,
  getCurrentUser,
  getEncryptionKey,
  getUserAccess,
  setUserPassword,
} from "./profileManager";
import {
  convertServerToRegularDate,
  convertServerToTimePickerString,
  convertTimePickerToServerTime,
  fomratDateToServerDate,
  formateDateTimeToServerDateString,
} from "./utilityFunctions";
import {
  dataURLToBlob,
  generateImageName,
  giveFormDataFromPrefTime,
  giveURLSchemeFromPrefTime,
} from "./webHelperManager";
import bcrypt from "bcryptjs";

//const baseUrl: string = "https://rana.teespire.com/backend/api";
const baseUrl: string = "https://www.test.rana-tt.com/backend/api";
//const baseUrl: string = "https://www.aze.rana-tt.com/backend/api";

//const baseUrl: string = "https://rana.teespire.com/backend/api";

export function timeout(delay: number) {
  return new Promise((res) => setTimeout(res, delay));
}

///////// ********************* Sign In/out *************************************
export function fetchSignInToken(
  username: string,
  password: string,
  callback: (auth_token: string, user_id: string, role: string) => void
) {
  let form: FormData = new FormData();
  form.append("email", username);
  form.append("password", password);
  postData(baseUrl + "/users/login ", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const user_id: string = responeObj.id;
    const auth_token: string = responeObj.auth_token;
    const role: string = responeObj.role;
    callback(auth_token, user_id, role);
  });
}

export function fetchLogOut(callback: (isSuccess: boolean) => void) {
  let form: FormData = new FormData();
  form.append("auth_token", getAuthToken());
  postData(baseUrl + "/users/logout ", form, (item: any) => {
    //const responeObj = JSON.parse(JSON.stringify(item));
    callback(true);
  });
}

export function fetchChangePassword(
  email: string,
  oldPassword: string,
  newPassword: string,
  callback: (isSuccess: boolean, message: string) => void
) {
  let form: FormData = new FormData();
  form.append("auth_token", getAuthToken());
  form.append("email", email);
  form.append("new_password", newPassword);
  form.append("old_password", oldPassword);
  postData(baseUrl + "/users/profile/password_reset", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    if (responeObj.id === undefined) {
      callback(false, responeObj);
    } else {
      callback(true, "");
    }
  });
}

export function fetchChangePasswordAdmin(
  email: string,
  newPassword: string,
  callback: (isSuccess: boolean, message: string) => void
) {
  let form: FormData = new FormData();
  form.append("auth_token", getAuthToken());
  form.append("email", email);
  form.append("password", newPassword);
  postData(baseUrl + "/users/admin/password_reset", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    if (responeObj.id === undefined) {
      callback(false, responeObj);
    } else {
      callback(true, "");
    }
  });
}

/////////// ************************ Users ****************************************
export function fetchAllUsers(callback: (array_users: UserModel[]) => void) {
  fetchData(baseUrl + "/users", async (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_users: UserModel[] = [];

    for (let i = 0; i < responeObj.length; i++) {
      const responseItem = responeObj[i];

      const mobile: string =
        responseItem.mobile !== null ? responseItem.mobile : "";
      const mobileSplit: string[] =
        mobile.split("-") !== null ? mobile.split("-") : ["", mobile];

      const userItem: UserModel = {
        user_id: responseItem.id,
        employee_id: responseItem.employee_reference_number,
        email_id: responseItem.email,
        //profile_pic_url: responseItem.profile_pic,
        profile_pic_url: "https://picsum.photos/seed/picsum/256",
        first_name: responseItem.first_name,
        last_name: responseItem.last_name,
        mobilePrefix: mobileSplit[0],
        mobile: mobileSplit[1],
        address: responseItem.address,
        working_status: convertWorkStatusViaKey(responseItem.status),
        user_city: responseItem.city,
        user_state: responseItem.city, //missing state
        user_zipcode: responseItem.zip_code,
        permanent_branch_id: responseItem.permanent_branch_id,
        permanant_branch: getBranchForId([], responseItem.permanent_branch_id),
        role: getUserRoleObjectForKey(responseItem.role),
        hourly_rate: responseItem.hourly_rate,
        pref_time: createPrefTimeArray(),
        toggleAbility: getUserToggleWithKey(responseItem.user_enabled),
        about_us: responseItem.about,
        gender: getGenderType(responseItem.gender),
      };
      array_users.push(userItem);
    }

    callback(array_users);
  });
}

export function fetchUsersForBranch(
  branch_id: string,
  callback: (array_users: UserModel[]) => void
) {
  const url: string = baseUrl + "/users/branch/" + branch_id;
  fetchData(url, async (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_users: UserModel[] = [];

    const isArray: boolean = Array.isArray(responeObj);
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const responseItem = responeObj[i];

        const mobile: string =
          responseItem.mobile !== null ? responseItem.mobile : "";
        const mobileSplit: string[] =
          mobile.split("-") !== null ? mobile.split("-") : ["", mobile];

        const userItem: UserModel = {
          user_id: responseItem.id,
          employee_id: responseItem.employee_reference_number,
          email_id: responseItem.email,
          //profile_pic_url: responseItem.profile_pic,
          profile_pic_url: "https://picsum.photos/256",
          first_name: responseItem.first_name,
          last_name: responseItem.last_name,
          mobilePrefix: mobileSplit[0],
          mobile: mobileSplit[1],
          address: responseItem.address,
          working_status: convertWorkStatusViaKey(responseItem.status),
          user_city: responseItem.city,
          user_state: responseItem.city, //missing state
          user_zipcode: responseItem.zip_code,
          permanent_branch_id: responseItem.permanent_branch_id,
          permanant_branch: getBranchForId([], responseItem.branch_id),
          role: getUserRoleObjectForKey(responseItem.role),
          hourly_rate: responseItem.hourly_rate,
          pref_time: createPrefTimeArray(),
          toggleAbility: getUserToggleWithKey(responseItem.user_enabled),
          about_us: responseItem.about,
          gender: getGenderType(responseItem.gender),
        };
        array_users.push(userItem);
      }
      callback(array_users);
    } else {
      callback([]);
    }
  });
}

export function fetchSingleUser(
  user_id: string,
  callback: (user: UserModel) => void
) {
  const url: string = baseUrl + "/users/" + user_id;
  fetchData(url, async (item: any) => {
    const responseItem = JSON.parse(JSON.stringify(item));

    if (responseItem.id !== undefined) {
      const mobile: string =
        responseItem.mobile !== null ? responseItem.mobile : "";
      const mobileSplit: string[] =
        mobile.split("-") !== null ? mobile.split("-") : ["", mobile];

      const userItem: UserModel = {
        user_id: responseItem.id,
        email_id: responseItem.email,
        employee_id: responseItem.employee_reference_number,
        //profile_pic_url: responseItem.profile_pic,
        profile_pic_url: "https://picsum.photos/seed/picsum/256",
        first_name: responseItem.first_name,
        last_name: responseItem.last_name,
        mobilePrefix: mobileSplit[0],
        mobile: mobileSplit[1],
        address: responseItem.address,
        working_status: convertWorkStatusViaKey(responseItem.status),
        user_city: responseItem.city,
        user_state: responseItem.city, //missing state
        user_zipcode: responseItem.zip_code,
        permanent_branch_id: responseItem.permanent_branch_id,
        permanant_branch: getBranchForId([], responseItem.permanent_branch_id),
        role: getUserRoleObjectForKey(responseItem.role),
        hourly_rate: responseItem.hourly_rate,
        pref_time: createPrefTimeArray(),
        toggleAbility: getUserToggleWithKey(responseItem.user_enabled),
        about_us: responseItem.about,
        gender: getGenderType(responseItem.gender),
      };
      callback(userItem);
    }
  });
}

export function deleteUserOnServer(
  user_id: string,
  callback: (isSuccess: boolean) => void
) {
  const url: string = baseUrl + "/users/" + user_id;
  deleteData(url, (item: any) => {
    callback(true);
  });
}

export async function postUserOnServer(
  user: UserModel,
  pass: string,
  callback: (isSuccess: boolean, user_id: string, message: string) => void
) {
  let form: FormData = new FormData();
  form.append("first_name", user.first_name);
  form.append("last_name", user.last_name);
  form.append("email", user.email_id);
  form.append("mobile", user.mobilePrefix + "-" + user.mobile);
  form.append("address", user.address);
  form.append("city", user.user_city);
  form.append("zip_code", user.user_zipcode);
  //form.append("state", user.user_state); missing variable

  form.append("permanent_branch_id", user.permanant_branch.branch_id);
  form.append("status", user.working_status.key); //not working yet
  form.append("about", user.about_us);
  form.append("gender", user.gender.key);
  if (user.password !== undefined) {
    form.append("password_hash", user.password);
    form.append("password", pass);
  }

  if (getUserAccess() === EnumUserAcces.ADMIN) {
    form.append("role", user.role.key); //not working
    form.append("hourly_rate", "" + user.hourly_rate);
    form.append("user_enabled", user.toggleAbility.key);
    form.append("employee_reference_number", user.employee_id);
  }

  postData(baseUrl + "/users", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const user_id: string = responeObj.id;
    const isSuccess: boolean = user_id !== undefined;
    callback(isSuccess, user_id, responeObj);
  });
}

export function updateUserInfo(
  user: UserModel,
  callback: (isSuccess: boolean) => void
) {
  let params: URLSearchParams = new URLSearchParams({
    id: "" + user.user_id,
    profile_pic: user.profile_pic_url,
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email_id,
    address: user.address,
    zip_code: user.user_zipcode,
    city: user.user_city,
    mobile: user.mobilePrefix + "-" + user.mobile,
  });
  params.append("hourly_rate", "" + user.hourly_rate);
  params.append("permanent_branch_id", user.permanant_branch.branch_id);
  params.append("status", user.working_status.key);
  params.append("role", "" + user.role.key);
  params.append("auth_key", getAuthToken());
  params.append("about", user.about_us);
  params.append("gender", user.gender.key);
  if (getUserAccess() === EnumUserAcces.ADMIN) {
    params.append("user_enabled", user.toggleAbility.key);
    params.append("employee_reference_number", user.employee_id);
  }

  const url: string = baseUrl + "/users/" + user.user_id;

  updateData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    callback(responeObj.id !== undefined);
  });
}

export function postImageToServer(
  imageFile: any,
  callback: (isSuccess: boolean, responseData: any, fileName: string) => void
) {
  let filename: string = generateImageName();
  let formData: FormData = new FormData();
  formData.append("profile_image", dataURLToBlob(imageFile), filename);
  //const url: string = baseUrl + "/users/profile/upload_image";
  const url: string = baseUrl + "/upload";
  let picUrl: string = url + "/" + filename;
  uploadImage(url, formData, (isSuccess: boolean, responseData: any) => {
    callback(isSuccess, responseData, picUrl);
  });
}

export function postUserDetailAndPrefsOnServer(
  user: UserModel,
  callback: (isSuccess: boolean) => void
) {
  let data = {
    user: {
      id: user.user_id,
      employee_reference_number: user.employee_id,
      profile_pic: user.profile_pic_url,
      first_name: user.first_name,
      middle_name: user.last_name,
      last_name: user.last_name,
      email: user.email_id,
      address: user.address,
      zip_code: user.user_zipcode,
      city: user.user_city,
      mobile: user.mobilePrefix + "-" + user.mobile,
      about: user.about_us,
      gender: user.gender.key,
      status: user.working_status.key, //not working yet
      //admin
      hourly_rate: "" + user.hourly_rate,
      role: user.role.key,
      permanent_branch_id: user.permanant_branch.branch_id,
      user_enabled: user.toggleAbility.key,
    },
    pref_time: user.pref_time.map((pref) => ({
      key: pref.day_key,
      start_at: convertTimePickerToServerTime(pref.start_time),
      end_at: convertTimePickerToServerTime(pref.end_time),
    })),
  };

  //console.log("postUserDetailAndPrefsOnServer data=", data);
  let json_data: string = JSON.stringify(data);
  let form: FormData = new FormData();
  //console.log("auth_token=", getAuthToken());
  //console.log("user_id=", user.user_id);
  //console.log("json_data=", json_data);

  form.append("auth_token", getAuthToken());
  form.append("user_id", user.user_id);
  form.append("user_json", json_data);
  //form.append("json", json_data);
  const url: string = baseUrl + "/users/create_update";
  postData(url, form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const user_id: string = responeObj.id;
    const isSuccess: boolean = user_id !== undefined;
    callback(isSuccess);
  });
}

export function fetchUserPrefDayTime(
  user: UserModel,
  callback: (array_prefDayTime: PreferredTimeModel[]) => void
) {
  const url: string = baseUrl + "/preferred_days/user/" + user.user_id;
  fetchData(url, async (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_prefDayTime: PreferredTimeModel[] = [];

    const isArray: boolean = Array.isArray(responeObj);
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const responseItem = responeObj[i];
        const userItem: PreferredTimeModel = {
          day_id: responseItem.id,
          day_key: responseItem.name,
          day_display: responseItem.name,
          start_time: convertServerToTimePickerString(responseItem.start_at),
          end_time: convertServerToTimePickerString(responseItem.end_at),
        };
        array_prefDayTime.push(userItem);
      }

      let tempPref: PreferredTimeModel[] = user.pref_time;
      for (let i = 0; i < array_prefDayTime.length; i++) {
        const sIndex = tempPref.findIndex(
          (x) => x.day_key === array_prefDayTime[i].day_key
        );
        if (sIndex !== -1) {
          tempPref[sIndex].day_id = array_prefDayTime[i].day_id;
          tempPref[sIndex].start_time = array_prefDayTime[i].start_time;
          tempPref[sIndex].end_time = array_prefDayTime[i].end_time;
        }
      }

      callback(tempPref);
    } else {
      callback(user.pref_time);
    }
  });
}

export function fetchPrefDayFromListOfUsers(
  array_users: UserModel[],
  callback: (isSuccess: boolean, array_users: UserModel[]) => void
) {
  let array_users_copy = array_users;
  const url: string = baseUrl + "/preferred_days/users";
  let user_ids: string = "";
  for (let i = 0; i < array_users.length; i++) {
    user_ids = user_ids + (i === 0 ? "" : ",") + array_users[i].user_id;
  }

  let params = new FormData();
  params.append("user_ids", user_ids);

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const isArray: boolean = Array.isArray(responeObj);
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const cUserId: string = responeObj[i].user_id + "";
        const xIndex = array_users_copy.findIndex((y) => y.user_id == cUserId);
        if (xIndex !== -1) {
          const currentUser: UserModel = array_users_copy[xIndex];
          const array_prefs = responeObj[i].days;
          let tempArray: PreferredTimeModel[] = [];
          for (let j = 0; j < array_prefs.length; j++) {
            const responseItem = array_prefs[j];
            const dayItem: PreferredTimeModel = {
              day_id: responseItem.id,
              day_key: responseItem.name,
              day_display: responseItem.name,
              start_time: convertServerToTimePickerString(
                responseItem.start_at
              ),
              end_time: convertServerToTimePickerString(responseItem.end_at),
            };
            tempArray.push(dayItem);
          }
          let tempPref: PreferredTimeModel[] = currentUser.pref_time;
          for (let j = 0; j < tempArray.length; j++) {
            const sIndex = tempPref.findIndex(
              (x) => x.day_key === tempArray[j].day_key
            );
            if (sIndex !== -1) {
              tempPref[sIndex].day_id = tempArray[j].day_id;
              tempPref[sIndex].start_time = tempArray[j].start_time;
              tempPref[sIndex].end_time = tempArray[j].end_time;
            }
          }
          array_users_copy[i].pref_time = tempPref;
        }
      }

      callback(true, array_users_copy);
    }
  });
}

export function updatePrefTime(
  user: UserModel,
  callback: (pref_time: PreferredTimeModel[]) => void
) {
  let tempArray = user.pref_time;
  for (let i = 0; i < tempArray.length; i++) {
    const pref: PreferredTimeModel = tempArray[i];
    if (pref.day_id === undefined) {
      postPrefDayTimeOnServer(
        user.user_id,
        pref,
        (isSuccess: boolean, pre_id: string) => {
          if (isSuccess) {
            tempArray[i].day_id = pre_id;
          }
        }
      );
    } else {
      updatePrefDayTime(user.user_id, pref, (isSuccess: boolean) => {
        console.log("pref time update=" + isSuccess);
      });
    }
  }
  callback(tempArray);
}

export async function postPrefDayTimeOnServer(
  user_id: string,
  pref_time: PreferredTimeModel,
  callback: (isSuccess: boolean, pref_id: string) => void
) {
  let form: FormData = giveFormDataFromPrefTime(user_id, pref_time);

  const url: string = baseUrl + "/preferred_days";
  postData(url, form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const pref_id: string = responeObj.id;
    const isSuccess: boolean = user_id !== null;
    callback(isSuccess, pref_id);
  });
}

export function updatePrefDayTime(
  user_id: string,
  pref_time: PreferredTimeModel,
  callback: (isSuccess: boolean) => void
) {
  if (pref_time.day_id === undefined) {
    return;
  }
  const params = giveURLSchemeFromPrefTime(user_id, pref_time);

  const url: string = baseUrl + "/preferred_days/" + pref_time.day_id;

  updateData(url, params, (item: any) => {
    callback(true);
  });
}
//****************************************** branch  **************************************/
export function postBranchOnServer(
  branch: BranchModel,
  callback: (isSuccess: boolean, branch_id: string) => void
) {
  let form: FormData = new FormData();
  form.append("name", branch.name);
  form.append("phone", branch.phone);
  form.append("address", branch.address);
  form.append("contact_name", branch.contact_name);
  form.append("contact_email", branch.contact_email);
  form.append("contact_phone", branch.contact_phone);

  postData(baseUrl + "/branches", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const branch_id: string = responeObj.id;
    const isSuccess: boolean = branch_id !== null;
    callback(isSuccess, branch_id);
  });
}

export function updateBranchInfo(
  branch: BranchModel,
  callback: (isSuccess: boolean) => void
) {
  let params: URLSearchParams = new URLSearchParams({
    id: "" + branch.branch_id,
    name: branch.name,
    address: branch.address,
    phone: branch.phone,
    contact_name: branch.contact_name,
    contact_email: branch.contact_email,
    contact_phone: branch.contact_phone,
  });
  updateData(baseUrl + "/branches/" + branch.branch_id, params, (item: any) => {
    callback(true);
  });
}

export function deleteBranchOnServer(
  branch: BranchModel,
  callback: (isSuccess: boolean) => void
) {
  deleteData(baseUrl + "/branches/" + branch.branch_id, (item: any) => {
    callback(true);
  });
}

export function fetchAllBranches(
  callback: (array_branches: BranchModel[]) => void
) {
  fetchData(baseUrl + "/branches", async (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_branches: BranchModel[] = [];
    for (let i = 0; i < responeObj.length; i++) {
      const responseitem = responeObj[i];
      const branchItem: BranchModel = {
        branch_id: responseitem.id,
        name: responseitem.name,
        address: responseitem.address,
        phone: responseitem.phone,
        contact_name: responseitem.contact_name,
        contact_email: responseitem.contact_email,
        contact_phone: responseitem.contact_phone,
      };
      array_branches.push(branchItem);
    }

    callback(array_branches);
  });
}

/* *************************************** Shifts ******************************************* */
export function fetchAllShifts(
  callback: (array_branches: ShiftModel[]) => void
) {
  fetchData(baseUrl + "/shifts", async (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_shifts: ShiftModel[] = [];
    for (let i = 0; i < responeObj.length; i++) {
      const responseitem = responeObj[i];
      const branchItem: ShiftModel = {
        shift_id: responseitem.id,
        title: responseitem.name,
        start_time: responseitem.start_at,
        end_time: responseitem.end_at,
      };
      array_shifts.push(branchItem);
    }

    callback(array_shifts);
  });
}

export function deleteShiftOnServer(
  shift: ShiftModel,
  callback: (isSuccess: boolean) => void
) {
  deleteData(baseUrl + "/shifts/" + shift.shift_id, (item: any) => {
    callback(true);
  });
}

export function updateShiftInfo(
  shift: ShiftModel,
  callback: (isSuccess: boolean) => void
) {
  let params: URLSearchParams = new URLSearchParams({
    id: "" + shift.shift_id,
    name: shift.title,
    start_at: shift.start_time,
    end_at: shift.end_time,
  });
  updateData(baseUrl + "/shifts/" + shift.shift_id, params, (item: any) => {
    callback(true);
  });
}

export function postShiftOnServer(
  shift: ShiftModel,
  callback: (isSuccess: boolean, shift_id: string) => void
) {
  let form: FormData = new FormData();
  form.append("name", shift.title);
  form.append("start_at", shift.start_time);
  form.append("end_at", shift.end_time);

  postData(baseUrl + "/shifts", form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const shift_id: string = responeObj.id;
    const isSuccess: boolean = shift_id !== null;
    callback(isSuccess, shift_id);
  });
}

/* *************************************** ***** ******************************************* */

/* *********************************** Shift Planer **************************************** */
export async function fetchShiftPlan(
  date: Date,
  branch_id: string,
  shift_id: string,
  callback: (shift_plan: ShiftPlanModel | undefined) => void
) {
  const date_string: string = fomratDateToServerDate(date);

  let form: FormData = new FormData();
  form.append("date", date_string);
  form.append("branch_id", branch_id);
  form.append("shift_id", shift_id);

  const url: string = baseUrl + "/shift_plan/get";
  postData(url, form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    if (responeObj.id !== undefined && responeObj.id !== -1) {
      let shift_plan: ShiftPlanModel = {
        plan_id: responeObj.id,
        branch_id: responeObj.branch_id,
        shift_id: responeObj.shift_id,
        date: responeObj.date,
        team_lead_id: responeObj.team_leader_id,
        branch: createBranch(),
        shift: createEmptyShiftObject(),
        array_employees: [],
      };
      //const responseArray = responeObj.plan_entries;
      const isArray: boolean = Array.isArray(responeObj.plan_entries);
      if (isArray) {
        let tempArray: ShiftPlanEmployee[] = [];
        for (let i = 0; i < responeObj.plan_entries.length; i++) {
          const temp_item = responeObj.plan_entries[i];
          const item: ShiftPlanEmployee = {
            id: temp_item.id,
            plan_id: temp_item.plan_id,
            user_id: temp_item.employee_id,
            employee_added_by_id: temp_item.employee_added_by_id,
            employee_start_at: temp_item.employee_start_at,
            employee_end_at: temp_item.employee_end_at,
            user: createUserModelObj(),
            current_state: EnumEmployeeShiftState.UNKNOWN,
            array_shift_entries: [],
          };
          tempArray.push(item);
        }
        shift_plan.array_employees = tempArray;
      }

      callback(shift_plan);
    } else {
      callback(undefined);
    }
  });
}

export async function fetchShiftPlanEmployees(
  shift_plan: ShiftPlanModel,
  callback: (shift_plan: ShiftPlanModel) => void
) {
  let tempShiftPlan = shift_plan;
  for (let i = 0; i < shift_plan.array_employees.length; i++) {
    const emp = shift_plan.array_employees[i];
    if (emp.user_id !== undefined && emp.user_id !== "-1") {
      // let user = await promiseUserFetch(emp.user_id)
      //   if (user !== undefined && user !== null) {
      //     const empUser: UserModel = user as UserModel;
      //     tempShiftPlan.array_employees[i].user = empUser;
      //   }

      await promiseUserFetch(emp.user_id).then((user) => {
        if (user !== undefined && user !== null) {
          const empUser: UserModel = user as UserModel;
          tempShiftPlan.array_employees[i].user = empUser;
        }
      });
    }
  }
  //Promise.allSettled
  callback(tempShiftPlan);
}

export function promiseUserFetch(user_id: string) {
  return new Promise((resolve) => {
    setTimeout(() => {
      fetchSingleUser(user_id, (user: UserModel) => {
        resolve(user);
      });
    });
  });
}

export function postShiftPlan(
  shift_plan: ShiftPlanModel,
  callback: (isSuccess: boolean, shift_plan_id: string) => void
) {
  let tl_id: string = "-1";
  const tlIndex = shift_plan.array_employees.findIndex(
    (x) => x.user.role.type === EnumUserAcces.TEAM_LEAD
  );
  if (tlIndex !== -1) {
    tl_id = shift_plan.array_employees[tlIndex].user.user_id;
  } else {
    const ttlIndex = shift_plan.array_employees.findIndex(
      (x) => x.user.tempRole?.type === EnumUserAcces.TEMP_TEAM_LEAD
    );
    if (ttlIndex !== -1) {
      tl_id = shift_plan.array_employees[ttlIndex].user.user_id;
    }
  }

  /*
  const plan_json = {
    date: shift_plan.date,
    branch_id: shift_plan.branch.branch_id,
    shift_id: shift_plan.shift.shift_id,
    team_leader_id: tl_id,
  };*/

  let params = new FormData();
  let serverDate: string = fomratDateToServerDate(shift_plan.date);
  params.append("date", serverDate);
  params.append("branch_id", shift_plan.branch.branch_id);
  params.append("shift_id", shift_plan.shift.shift_id);
  params.append("team_leader_id", tl_id);

  let url: string = baseUrl + "/shift_plan";
  if (shift_plan.plan_id !== undefined) {
    params.append("plan_id", shift_plan.plan_id);
    url = baseUrl + "/shift_plan/" + shift_plan.plan_id;
  }
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const plan_id: string = responeObj.id;
    const isSuccess: boolean = plan_id !== null;
    callback(isSuccess, plan_id);
  });
}

export function postShiftPlanEntries(
  shift_plan: ShiftPlanModel,
  callback: (isSuccess: boolean) => void
) {
  let array_entries = [];
  for (let i = 0; i < shift_plan.array_employees.length; i++) {
    const shiftPlanEmployee = shift_plan.array_employees[i];
    let entry = {
      plan_id: shift_plan.plan_id !== undefined ? shift_plan.plan_id : "-1",
      employee_id: shiftPlanEmployee.user.user_id,
      employee_added_by_id: getCurrentUser().user_id,
      employee_start_at:
        shiftPlanEmployee.employee_start_at !== undefined
          ? shiftPlanEmployee.employee_start_at
          : "------",
      employee_end_at:
        shiftPlanEmployee.employee_end_at !== undefined
          ? shiftPlanEmployee.employee_end_at
          : "------",
    };

    array_entries.push(entry);
  }
  const shift_entries = { plan_entries: array_entries };

  let params = new FormData();
  let data: string = JSON.stringify(shift_entries);
  params.append("json", data);
  //params.append("json", JSON.stringify(shift_entries));

  //let url: string = baseUrl + "/shift_plan_entries_bulk";
  let url = baseUrl + "/shift_plan_entries_bulk/edit/" + shift_plan.plan_id;
  /*
  if (shift_plan.plan_id !== undefined) {
    url = baseUrl + "/shift_plan_entries_bulk/edit/" + shift_plan.plan_id;
  }*/
  postData(url, params, (item: any, status_code: number) => {
    //const responeObj = JSON.parse(JSON.stringify(item));
    callback(status_code === 200);
  });
}

export function fetchBranchUsersForShiftPlaner(
  date: Date,
  branch_id: string,
  shift_id: string,
  callback: (array_employees: UserModel[]) => void
) {
  const date_string: string = fomratDateToServerDate(date);

  let form: FormData = new FormData();
  form.append("date", date_string);
  form.append("branch_id", branch_id);
  form.append("shift_id", shift_id);

  const url: string = baseUrl + "/shift_plan/branch/users/get";
  postData(url, form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    if (Array.isArray(responeObj)) {
      const array_employees: UserModel[] = [];
      for (let i = 0; i < responeObj.length; i++) {
        const responseItem = responeObj[i];
        const mobile: string =
          responseItem.mobile !== null ? responseItem.mobile : "";
        const mobileSplit: string[] =
          mobile.split("-") !== null ? mobile.split("-") : ["", mobile];

        const employee: UserModel = {
          user_id: responseItem.id,
          employee_id: responseItem.employee_reference_number,
          email_id: responseItem.email,
          //profile_pic_url: responseItem.profile_pic,
          profile_pic_url: "https://picsum.photos/256",
          first_name: responseItem.first_name,
          last_name: responseItem.last_name,
          mobilePrefix: mobileSplit[0],
          mobile: mobileSplit[1],
          address: responseItem.address,
          working_status: convertWorkStatusViaKey(responseItem.status),
          user_city: responseItem.city,
          user_state: responseItem.city, //missing state
          user_zipcode: responseItem.zip_code,
          permanent_branch_id: responseItem.permanent_branch_id,
          permanant_branch: getBranchForId([], responseItem.branch_id),
          role: getUserRoleObjectForKey(responseItem.role),
          hourly_rate: responseItem.hourly_rate,
          pref_time: createPrefTimeArray(),
          toggleAbility: getUserToggleWithKey(responseItem.user_enabled),
          about_us: responseItem.about,
          gender: getGenderType(responseItem.gender),
        };
        array_employees.push(employee);
      }

      callback(array_employees);
    } else {
      callback([]);
    }
  });
}

/* *********************************** Team Lead functions **************************************** */

export async function fetchShiftPlanForTeamLead(
  date: Date,
  team_lead_id: string,
  callback: (shift_plan: ShiftPlanModel | undefined) => void
) {
  const date_string: string = fomratDateToServerDate(date);

  let form: FormData = new FormData();
  form.append("date", date_string);
  form.append("team_leader_id", team_lead_id);

  const url: string = baseUrl + "/shift_plan/team_lead/get";
  postData(url, form, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    if (responeObj.id !== undefined && responeObj.id !== -1) {
      let shift_plan: ShiftPlanModel = {
        plan_id: responeObj.id,
        branch_id: responeObj.branch_id,
        shift_id: responeObj.shift_id,
        date: responeObj.date,
        team_lead_id: responeObj.team_leader_id,
        log_id: responeObj.shift_log_id,
        branch: createBranch(),
        shift: createEmptyShiftObject(),
        array_employees: [],
      };
      //const responseArray = responeObj.plan_entries;
      const isArray: boolean = Array.isArray(responeObj.plan_entries);
      if (isArray) {
        let tempArray: ShiftPlanEmployee[] = [];
        for (let i = 0; i < responeObj.plan_entries.length; i++) {
          const temp_item = responeObj.plan_entries[i];
          const item: ShiftPlanEmployee = {
            id: temp_item.id,
            plan_id: temp_item.plan_id,
            user_id: temp_item.employee_id,
            employee_added_by_id: temp_item.employee_added_by_id,
            employee_start_at: temp_item.employee_start_at,
            employee_end_at: temp_item.employee_end_at,
            user: createUserModelObj(),
            current_state: EnumEmployeeShiftState.UNKNOWN,
            array_shift_entries: [],
          };
          tempArray.push(item);
        }
        shift_plan.array_employees = tempArray;
      }

      callback(shift_plan);
    } else {
      callback(undefined);
    }
  });
}

export function fetchListOfUsersForTeamLead(
  shift_plan: ShiftPlanModel,
  callback: (shift_plan: ShiftPlanModel) => void
) {
  let user_ids: string = "";
  for (let i = 0; i < shift_plan.array_employees.length; i++) {
    user_ids =
      user_ids + (i === 0 ? "" : ",") + shift_plan.array_employees[i].user_id;
  }
  let tempShiftPlan = shift_plan;
  fetchListOfUserByIds(user_ids, (array_users: UserModel[]) => {
    for (let i = 0; i < array_users.length; i++) {
      const uIndex: number = tempShiftPlan.array_employees.findIndex(
        (x) => x.user_id === array_users[i].user_id
      );
      if (uIndex !== -1) {
        tempShiftPlan.array_employees[uIndex].user = array_users[i];
      }
    }
    fetchListOfEmployeePasswords(tempShiftPlan, (sp: ShiftPlanModel) => {
      tempShiftPlan = sp;

      //save team lead password in local storage
      const tlIndex: number = tempShiftPlan.array_employees.findIndex(
        (x) => x.user.user_id === tempShiftPlan.team_lead_id
      );
      if (tlIndex !== -1) {
        const tlPass: string | undefined =
          tempShiftPlan.array_employees[tlIndex].user.password;
        if (tlPass !== undefined && tlPass !== null) {
          setUserPassword(tlPass);
        }
      }
      callback(tempShiftPlan);
    });
    //callback(tempShiftPlan);
  });
}

export function fetchListOfUserByIds(
  userIds: string,
  callback: (array_users: UserModel[]) => void
) {
  const url: string = baseUrl + "/users/details";
  let params = new FormData();
  params.append("user_ids", userIds);

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_users: UserModel[] = [];

    const isArray: boolean = Array.isArray(responeObj.users);
    if (isArray) {
      for (let i = 0; i < responeObj.users.length; i++) {
        const responseItem = responeObj.users[i];

        const mobile: string =
          responseItem.mobile !== null ? responseItem.mobile : "";
        const mobileSplit: string[] =
          mobile.split("-") !== null ? mobile.split("-") : ["", mobile];

        const userItem: UserModel = {
          user_id: responseItem.id,
          employee_id: responseItem.employee_reference_number,
          email_id: responseItem.email,
          //profile_pic_url: responseItem.profile_pic,
          profile_pic_url: "https://picsum.photos/256",
          first_name: responseItem.first_name,
          last_name: responseItem.last_name,
          mobilePrefix: mobileSplit[0],
          mobile: mobileSplit[1],
          address: responseItem.address,
          working_status: convertWorkStatusViaKey(responseItem.status),
          user_city: responseItem.city,
          user_state: responseItem.city, //missing state
          user_zipcode: responseItem.zip_code,
          permanent_branch_id: responseItem.permanent_branch_id,
          permanant_branch: getBranchForId([], responseItem.branch_id),
          role: getUserRoleObjectForKey(responseItem.role),
          hourly_rate: responseItem.hourly_rate,
          pref_time: createPrefTimeArray(),
          toggleAbility: getUserToggleWithKey(responseItem.user_enabled),
          about_us: responseItem.about,
          gender: getGenderType(responseItem.gender),
        };
        array_users.push(userItem);
      }
      callback(array_users);
    } else {
      callback([]);
    }
  });
}

export function fetchShiftLog(
  log_id: string,
  callback: (isSuccess: boolean, shift_log: ShiftLogModel) => void
) {
  const url: string = baseUrl + "/shift_log/" + log_id;
  fetchData(url, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const log_id: string = responeObj.id;
    if (log_id !== null) {
      const log: ShiftLogModel = {
        id: responeObj.id,
        plan_id: responeObj.plan_id,
        approval_status: responeObj.approval_status,
        approved_by_user_id: responeObj.approved_by_user_id,
        comments: responeObj.comments,
        end_at: responeObj.end_at,
      };
      callback(true, log);
    } else {
      callback(false, {
        id: "",
        plan_id: "",
        approval_status: false,
        approved_by_user_id: "",
        comments: "",
        end_at: "",
      });
    }
  });
}

export function postShiftlog(
  shift_plan: ShiftPlanModel,
  callback: (log_id: string) => void
) {
  const url: string = baseUrl + "/shift_log";
  let params = new FormData();
  params.append("plan_id", shift_plan.plan_id as string);
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const log_id: string = responeObj.id;
    callback(log_id);
  });
}

export function updateShiftLog(
  shift_log: ShiftLogModel,
  callback: (isSuccess: boolean, shift_log: ShiftLogModel) => void
) {
  const url: string = baseUrl + "/shift_log/" + shift_log.id;
  let params: URLSearchParams = new URLSearchParams({
    id: "" + shift_log.id,
    plan_id: shift_log.plan_id,
    approval_status: shift_log.approval_status ? "true" : "false",
    comments: shift_log.comments,
    end_at: shift_log.end_at,
  });
  if (
    shift_log.approved_by_user_id !== undefined &&
    shift_log.approved_by_user_id != null &&
    shift_log.approved_by_user_id !== ""
  ) {
    params.append("approved_by_user_id", shift_log.approved_by_user_id);
  }

  updateData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const log_id: string = responeObj.id;
    const log: ShiftLogModel = {
      id: log_id,
      plan_id: responeObj.plan_id,
      approval_status: responeObj.approval_status,
      comments: responeObj.comments,
      approved_by_user_id: responeObj.approved_by_user_id,
      end_at: responeObj.end_at,
    };
    callback(log_id === null || log_id === undefined ? false : true, log);
  });
}

export function fetchShiftlogEntries(
  shift_log_id: string,
  callback: (array_entries: ShiftEmployeeEntries[]) => void
) {
  const url: string = baseUrl + "/shift_log_entries/log/" + shift_log_id;
  fetchData(url, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_entries: ShiftEmployeeEntries[] = [];
    const isArray: boolean = Array.isArray(responeObj);
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const tempObj = responeObj[i];
        const entry: ShiftEmployeeEntries = {
          entry_id: tempObj.id,
          user_id: tempObj.user_id,
          shift_log_id: tempObj.shift_log_id,
          start_time: tempObj.start_at,
          end_time: tempObj.end_at,
          ended_by_id: tempObj.ended_by_id,
        };
        array_entries.push(entry);
      }
    }
    callback(array_entries);
  });
}

export function updateLogEntry(
  log_entry: ShiftEmployeeEntries,
  callback: (isSuccess: boolean) => void
) {
  const url: string = baseUrl + "/shift_log_entries/" + log_entry.entry_id;
  const end_at: string =
    log_entry.end_time !== undefined ||
    log_entry.end_time !== null ||
    log_entry.end_time !== ""
      ? (log_entry.end_time as string)
      : "";
  let ended_by_id: string =
    log_entry.ended_by_id !== undefined ||
    log_entry.ended_by_id !== null ||
    log_entry.ended_by_id !== ""
      ? (log_entry.ended_by_id as string)
      : "-1";
  let params: URLSearchParams = new URLSearchParams({
    id: log_entry.entry_id as string,
    user_id: log_entry.user_id as string,
    shift_log_id: log_entry.shift_log_id as string,
    start_at: log_entry.start_time,
    end_at: end_at,
  });
  if (ended_by_id !== null && ended_by_id !== undefined && ended_by_id !== "") {
    params.append("ended_by_id", ended_by_id);
  }

  updateData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const log_id: string = responeObj.id;
    callback(Number(log_id) > 0 ? true : false);
  });
}

export function postLogEntry(
  user_id: string,
  shift_log_id: string,
  start_time: Date,
  callback: (isSuccess: boolean, log_id: string) => void,
  end_time?: Date,
  ended_by_id?: string
) {
  const url: string = baseUrl + "/shift_log_entries";

  const start_at: string = formateDateTimeToServerDateString(start_time);
  let params = new FormData();
  params.append("user_id", user_id);
  params.append("start_at", start_at);
  params.append("shift_log_id", shift_log_id);
  if (end_time !== undefined && end_time !== null) {
    params.append("end_at", formateDateTimeToServerDateString(end_time));
  }
  if (ended_by_id !== null && ended_by_id !== undefined && ended_by_id !== "") {
    params.append("ended_by_id", ended_by_id);
  }

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const entry_id: string = responeObj.id;
    //console.log("postLogEntry=" + JSON.stringify(responeObj));
    callback(Number(entry_id) > 0 ? true : false, entry_id);
  });
}

export function fetchListOfEmployeePasswords(
  shift_plan: ShiftPlanModel,
  callback: (shift_plan: ShiftPlanModel) => void
) {
  let user_ids: string = "";
  for (let i = 0; i < shift_plan.array_employees.length; i++) {
    user_ids =
      user_ids +
      (i === 0 ? "" : ",") +
      shift_plan.array_employees[i].user.user_id;
  }
  const url: string = baseUrl + "/users/team_lead/get_passwords";
  let params = new FormData();
  params.append("user_ids", user_ids);

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    let array_users: ShiftPlanEmployee[] = shift_plan.array_employees;

    const isArray: boolean = Array.isArray(responeObj);
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const responseItem = responeObj[i];

        const iIndex: number = shift_plan.array_employees.findIndex(
          (x) => x.user.user_id == responseItem.user_id
        );
        if (iIndex !== -1) {
          //let userItem: UserModel = shift_plan.array_employees[iIndex].user;
          //userItem.password = responseItem.password;
          //array_users.push(userItem);
          array_users[iIndex].user.password = responseItem.password;
        }
      }
      shift_plan.array_employees = array_users;
      callback(shift_plan);
    } else {
      callback(shift_plan);
    }
  });
}

/* *********************************** Branch Manager ********************************** */
export function fetchBranchListReport(
  date_: Date,
  branch_id: string,
  callback: (array_reports: ReportModel[]) => void
) {
  const url: string = baseUrl + "/shift_plan/reports/list/branch_manager/get";
  const date_string: string = fomratDateToServerDate(date_);
  const params = new FormData();
  params.append("date", date_string);
  //params.append("branch_id", branch_id);
  params.append("branch_id", branch_id);
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const isArray: boolean = Array.isArray(responeObj);
    let array_reports: ReportModel[] = [];
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const item_shift_plan = responeObj[i].shift_plan;
        const item_team_leader = responeObj[i].team_leader;
        const item_branch = responeObj[i].branch;
        const item_shift = responeObj[i].shift;
        const item_shift_log = responeObj[i].shift_log;
        if (
          item_shift_log === null ||
          item_shift_plan === null ||
          item_team_leader === null ||
          item_branch === null ||
          item_shift === null
        ) {
          continue;
        }
        const shift_info: ShiftModel = {
          shift_id: item_shift.id,
          title: item_shift.name,
          start_time: item_shift.start_at,
          end_time: item_shift.end_at,
        };
        const shift_log: ShiftLogModel = {
          id: item_shift_log.id,
          plan_id: item_shift_log.plan_id,
          approval_status:
            item_shift_log.approved_by_user_id === null
              ? false
              : item_shift_log.approval_status,
          approved_by_user_id: item_shift_log.approved_by_user_id,
          comments: item_shift_log.comments,
          end_at: item_shift_log.end_at,
        };
        const branch_info: BranchModel = {
          branch_id: item_branch.id,
          name: item_branch.name,
          address: item_branch.address,
          phone: item_branch.phone,
          contact_name: item_branch.contact_name,
          contact_email: item_branch.contact_email,
          contact_phone: item_branch.contact_phone,
        };
        const shift_plan_info: ShiftPlanModel = {
          plan_id: item_shift_plan.id,
          shift_id: item_shift_plan.id,
          date: item_shift_plan.date,
          shift: shift_info,
          branch: branch_info,
          log: shift_log,
          log_id: shift_log.id,
          team_lead_id: item_team_leader.id,
          array_employees: [],
        };
        const team_lead_info: UserModel = {
          user_id: item_team_leader.id,
          email_id: item_team_leader.email,
          employee_id: item_team_leader.employee_reference_number,
          profile_pic_url: item_team_leader.profile_pic,
          first_name: item_team_leader.first_name,
          last_name: item_team_leader.last_name,
          mobilePrefix: item_team_leader.mobile,
          mobile: item_team_leader.mobile,
          address: item_team_leader.address,
          working_status: convertWorkStatusViaKey(item_team_leader.status),
          user_city: item_team_leader.city,
          user_state: item_team_leader.city,
          user_zipcode: item_team_leader.zip_code,
          permanent_branch_id: item_team_leader,
          permanant_branch: branch_info,
          role: getUserRoleObjectForKey(item_team_leader.role),
          hourly_rate: item_team_leader.hourly_rate,
          pref_time: [],
          toggleAbility: getUserToggleEnabled(true),
          about_us: item_team_leader.about,
          gender: getGenderType(item_team_leader.gender),
        };
        const report: ReportModel = {
          report_id: 0,
          title: "Report No-" + shift_log.id,
          department_id: 0,
          department: "",
          signatory: "",
          description: "",
          filename: "",
          shift_plan: shift_plan_info,
          team_lead_info: team_lead_info,
        };
        array_reports.push(report);
      }
      callback(array_reports);
    } else {
      callback([]);
    }
  });
}

export function fetchReportDetail(
  plan_id: string,
  callback: (reportShiftPlan: ShiftPlanModel) => void
) {
  const url: string = baseUrl + "/shift_plan/report/details";
  const params = new FormData();
  params.append("plan_id", plan_id);
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const shift_item = responeObj.shift_plan;
    const shift_log = responeObj.shift_log;
    const array_sp_entries = responeObj.shift_plan_entries;
    const array_log_entries = responeObj.shift_log_entries;

    let array_shiftEntries: ShiftPlanEmployee[] = [];
    if (Array.isArray(array_sp_entries)) {
      for (let i = 0; i < array_sp_entries.length; i++) {
        const itemShiftEntry = array_sp_entries[i];
        const itemEmployeeDetail = itemShiftEntry.employee_details;

        const employee: UserModel = {
          user_id: itemEmployeeDetail.id,
          email_id: itemEmployeeDetail.email,
          employee_id: itemEmployeeDetail.employee_reference_number,
          profile_pic_url: itemEmployeeDetail.profile_pic,
          first_name: itemEmployeeDetail.first_name,
          last_name: itemEmployeeDetail.last_name,
          mobilePrefix: itemEmployeeDetail.mobile,
          mobile: itemEmployeeDetail.mobile,
          address: itemEmployeeDetail.address,
          working_status: convertWorkStatusViaKey(itemEmployeeDetail.status),
          user_city: itemEmployeeDetail.city,
          user_state: itemEmployeeDetail.city,
          user_zipcode: itemEmployeeDetail.zip_code,
          permanent_branch_id: itemEmployeeDetail.permanent_branch_id,
          role: getUserRoleObjectForKey(itemEmployeeDetail.role),
          hourly_rate: itemEmployeeDetail.hourly_rate,
          pref_time: [],
          permanant_branch: noneBranchObject(),
          toggleAbility: getUserToggleWithKey(itemEmployeeDetail.user_enabled),
          about_us: itemEmployeeDetail.about,
          gender: getGenderType(itemEmployeeDetail.gender),
        };
        let shiftEmployee: ShiftPlanEmployee = {
          user: employee,
          current_state: EnumEmployeeShiftState.SHIFT_ENDED,
          array_shift_entries: [],
        };
        array_shiftEntries.push(shiftEmployee);
      }
    }

    //let array_logEntries: ShiftEmployeeEntries[] = [];
    if (Array.isArray(array_log_entries)) {
      for (let i = 0; i < array_log_entries.length; i++) {
        const itemLogEntry = array_log_entries[i];
        const log_entry: ShiftEmployeeEntries = {
          entry_id: itemLogEntry.id,
          user_id: itemLogEntry.user_id,
          shift_log_id: itemLogEntry.shift_log_id,
          start_time: itemLogEntry.start_at,
          end_time: itemLogEntry.end_at,
          ended_by_id: itemLogEntry.ended_by_id,
        };
        const logIndex: number = array_shiftEntries.findIndex(
          (x) => x.user.user_id === log_entry.user_id
        );
        if (logIndex !== -1) {
          array_shiftEntries[logIndex].array_shift_entries.push(log_entry);
        }
        //array_logEntries.push(log_entry);
      }
    }
    const shiftLogEle: ShiftLogModel = {
      id: shift_log.id,
      plan_id: shift_log.plan_id,
      approval_status: shift_log.approval_status,
      approved_by_user_id: shift_log.approved_by_user_id,
      comments: shift_log.comments,
      end_at: shift_log.end_at,
    };

    let shiftPlanEle: ShiftPlanModel = {
      plan_id: shift_item.id,
      log_id: shiftLogEle.id,
      branch_id: shift_item.branch_id,
      shift_id: shift_item.shift_id,
      team_lead_id: shift_item.team_leader_id,
      date: new Date(shift_item.date),
      shift: noneShiftObject(),
      branch: noneBranchObject(),
      array_employees: array_shiftEntries,
      log: shiftLogEle,
    };

    callback(shiftPlanEle);
  });
}

/* ************************************ reports *********************************** */
export function fetchAdminReportsDaily(
  date: Date,
  callback: (array_reports: ReportModel[]) => void
) {
  const date_string: string = fomratDateToServerDate(date);
  const url: string = baseUrl + "/shift_plan/reports/list/admin/daily-branch";
  const params = new FormData();
  //params.append("branch_id", branch.branch_id);
  params.append("input_date", date_string);
  params.append("auth_key", getAuthToken());
  postData(url, params, (item: any) => {
    //fetchData(url, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const isArray: boolean = Array.isArray(responeObj);
    let array_reports: ReportModel[] = [];
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const item_shift_plan = responeObj[i].shift_plan;
        const item_team_leader = responeObj[i].team_leader;
        const item_shift = responeObj[i].shift;
        const item_shift_log = responeObj[i].shift_log;
        const item_approved_by = responeObj[i].approved_by_user;
        if (
          item_shift_log === null ||
          item_shift_plan === null ||
          item_team_leader === null ||
          item_shift === null ||
          item_approved_by === null
        ) {
          continue;
        }
        const shift_info: ShiftModel = {
          shift_id: item_shift.id,
          title: item_shift.name,
          start_time: item_shift.start_at,
          end_time: item_shift.end_at,
        };
        const shift_log: ShiftLogModel = {
          id: item_shift_log.id,
          plan_id: item_shift_log.plan_id,
          approval_status: item_shift_log.approval_status,
          approved_by_user_id: item_shift_log.approved_by_user_id,
          comments: item_shift_log.comments,
          end_at: item_shift_log.end_at,
        };

        const shift_plan_info: ShiftPlanModel = {
          plan_id: item_shift_plan.id,
          shift_id: item_shift_plan.id,
          date: item_shift_plan.date,
          shift: shift_info,
          branch: noneBranchObject(),
          log: shift_log,
          log_id: shift_log.id,
          team_lead_id: item_team_leader.id,
          array_employees: [],
        };
        const team_lead_info: UserModel = {
          user_id: item_team_leader.id,
          email_id: item_team_leader.email,
          employee_id: item_team_leader.employee_reference_number,
          profile_pic_url: item_team_leader.profile_pic,
          first_name: item_team_leader.first_name,
          last_name: item_team_leader.last_name,
          mobilePrefix: item_team_leader.mobile,
          mobile: item_team_leader.mobile,
          address: item_team_leader.address,
          working_status: convertWorkStatusViaKey(item_team_leader.status),
          user_city: item_team_leader.city,
          user_state: item_team_leader.city,
          user_zipcode: item_team_leader.zip_code,
          permanent_branch_id: item_team_leader,
          permanant_branch: noneBranchObject(),
          role: getUserRoleObjectForKey(item_team_leader.role),
          hourly_rate: item_team_leader.hourly_rate,
          pref_time: [],
          toggleAbility: getUserToggleWithKey(item_team_leader.user_enabled),
          about_us: item_team_leader.about,
          gender: getGenderType(item_team_leader.gender),
        };
        const approve_by_user: UserModel = {
          user_id: item_approved_by.id,
          email_id: item_approved_by.email,
          employee_id: item_approved_by.employee_reference_number,
          profile_pic_url: item_approved_by.profile_pic,
          first_name: item_approved_by.first_name,
          last_name: item_approved_by.last_name,
          mobilePrefix: item_approved_by.mobile,
          mobile: item_approved_by.mobile,
          address: item_approved_by.address,
          working_status: convertWorkStatusViaKey(item_team_leader.status),
          user_city: item_approved_by.city,
          user_state: item_approved_by.city,
          user_zipcode: item_approved_by.zip_code,
          permanent_branch_id: item_approved_by,
          permanant_branch: noneBranchObject(),
          role: getUserRoleObjectForKey(item_approved_by.role),
          hourly_rate: item_approved_by.hourly_rate,
          pref_time: [],
          toggleAbility: getUserToggleWithKey(item_approved_by.user_enabled),
          about_us: item_approved_by.about,
          gender: getGenderType(item_approved_by.gender),
        };
        let department: string = "";
        let d_id: number = 0;
        if (
          responeObj[i].branch !== undefined &&
          responeObj[i].branch !== null
        ) {
          department = responeObj[i].branch.name;
          d_id = responeObj[i].branch.name.id;
        }
        const report: ReportModel = {
          report_id: 0,
          title: department + shift_log.id,
          department_id: d_id,
          department: department,
          signatory:
            approve_by_user.first_name + " " + approve_by_user.last_name,
          description: "",
          filename: "",
          shift_plan: shift_plan_info,
          team_lead_info: team_lead_info,
          approved_by_info: approve_by_user,
        };
        array_reports.push(report);
      }
      callback(array_reports);
    } else {
      callback([]);
    }
  });
}

export function fetchEmployeeReport(
  startDate: Date,
  endDate: Date,
  callback: (array_reports: EmployeeReportModel[]) => void
) {
  const start_date_string: string = fomratDateToServerDate(startDate);
  const end_date_string: string = fomratDateToServerDate(endDate);

  const url: string = baseUrl + "/shift_plan/reports/admin/employees";
  const params = new FormData();
  params.append("start_date", start_date_string);
  params.append("end_date", end_date_string);
  params.append("auth_key", getAuthToken());
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    //console.log(JSON.stringify(item));
    const isArray: boolean = Array.isArray(responeObj);
    let array_reports: EmployeeReportModel[] = [];
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const item = responeObj[i].employee_details;
        const employee: UserModel = {
          user_id: item.id,
          email_id: item.email,
          employee_id: item.employee_reference_number,
          profile_pic_url: item.profile_pic,
          first_name: item.first_name,
          last_name: item.last_name,
          mobilePrefix: item.mobile,
          mobile: item.mobile,
          address: item.address,
          working_status: convertWorkStatusViaKey(item.status),
          user_city: item.city,
          user_state: item.city,
          user_zipcode: item.zip_code,
          permanent_branch_id: item,
          permanant_branch: noneBranchObject(),
          role: getUserRoleObjectForKey(item.role),
          hourly_rate: item.hourly_rate,
          pref_time: [],
          toggleAbility: getUserToggleWithKey(item.user_enabled),
          about_us: item.about,
          gender: getGenderType(item.gender),
        };
        /* Parse log entries */
        const entries_json = responeObj[i].shift_log_entries;
        let array_logs: ShiftEmployeeEntries[] = [];
        if (Array.isArray(entries_json)) {
          for (let j = 0; j < entries_json.length; j++) {
            const entry = entries_json[j];
            const log_entry: ShiftEmployeeEntries = {
              user_id: "",
              shift_log_id: "",
              start_time: entry.employee_start_time,
              end_time: entry.employee_end_time,
              branch_name: entry.branch_name,
            };
            array_logs.push(log_entry);
          }
        }
        let timeinsecs: number = calculateTotalIntervalInSeconds(array_logs);
        timeinsecs = isNaN(timeinsecs) ? 0 : timeinsecs;
        const report: EmployeeReportModel = {
          user: employee,
          array_logEntries: array_logs,
          total_time_in_seconds: timeinsecs,
          working_hours: calculateEmployeeElapsedTime(array_logs),
          total_earning: calculateEmployeeEarning(
            timeinsecs,
            employee.hourly_rate
          ),
        };
        array_reports.push(report);
      }
      callback(array_reports);
    } else {
      callback([]);
    }
  });
}

export function fetchBranchReport(
  startDate: Date,
  endDate: Date,
  callback: (array_reports: BranchReportModel[]) => void
) {
  const start_date_string: string = fomratDateToServerDate(startDate);
  const end_date_string: string = fomratDateToServerDate(endDate);

  const url: string = baseUrl + "/shift_plan/reports/admin/branches";
  const params = new FormData();
  params.append("start_date", start_date_string);
  params.append("end_date", end_date_string);
  params.append("auth_key", getAuthToken());
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const isArray: boolean = Array.isArray(responeObj);
    let array_reports: BranchReportModel[] = [];
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const item_branch = responeObj[i].branch;
        const branch_ele: BranchModel = {
          branch_id: item_branch.id,
          name: item_branch.name,
          address: item_branch.address,
          phone: item_branch.phone,
          contact_name: item_branch.contact_name,
          contact_email: item_branch.contact_email,
          contact_phone: item_branch.contact_phone,
        };
        /* Parse log entries */
        const entries_json = responeObj[i].shift_log_entries;
        let array_logs: ShiftEmployeeEntries[] = [];
        if (Array.isArray(entries_json)) {
          for (let j = 0; j < entries_json.length; j++) {
            const entry = entries_json[j];
            const log_entry: ShiftEmployeeEntries = {
              user_id: "",
              shift_log_id: "",
              start_time: entry.start_time,
              end_time: entry.end_time,
            };
            array_logs.push(log_entry);
          }
        }
        const timeinsecs: number = calculateTotalIntervalInSeconds(array_logs);
        const reportModel: BranchReportModel = {
          branch: branch_ele,
          array_log_entries: array_logs,
          total_hours: timeinsecs,
          working_hours: calculateEmployeeElapsedTime(array_logs),
        };

        array_reports.push(reportModel);
      }
      callback(array_reports);
    } else {
      callback([]);
    }
  });
}

// ************************** Pending Requests *************************
export function sendJoinRequestToTeamLead(
  email: string,
  employee_user_id: string,
  callback: (isSuccess: boolean, message: string) => void
) {
  let params = new FormData();
  params.append("team_lead_email", email);
  params.append("employee_id", employee_user_id);
  params.append("auth_key", getAuthToken());
  const url: string = baseUrl + "/branches/join_request";

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const entry_id: string = responeObj.team_leader_id;

    const isSuccess: boolean = entry_id !== undefined;
    callback(isSuccess, item as string);
  });
}

export function fetchTeamLeadPendingRequests(
  team_lead_id: string,
  callback: (arry_requests: TempBranchPendingRequestModel[]) => void
) {
  let params = new FormData();
  params.append("team_lead_id", team_lead_id);
  params.append("auth_key", getAuthToken());
  const url: string = baseUrl + "/branches/pending_requests";

  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const employeesArr = responeObj.employees;

    const isArray: boolean = Array.isArray(employeesArr);
    if (isArray) {
      let array_requests: TempBranchPendingRequestModel[] = [];
      for (let i = 0; i < employeesArr.length; i++) {
        const item = employeesArr[i];
        const user: UserModel = {
          user_id: item.id,
          email_id: item.email,
          employee_id: item.employee_reference_number,
          profile_pic_url: item.profile_pic,
          first_name: item.first_name,
          last_name: item.last_name,
          mobilePrefix: "",
          mobile: "",
          address: "",
          working_status: convertWorkStatusViaKey(item.status),
          user_city: "",
          user_state: "",
          user_zipcode: "",
          permanent_branch_id: "",
          permanant_branch: getBranchForId([], item.permanent_branch_id),
          role: getUserRoleObjectForKey(item.role),
          hourly_rate: 0,
          pref_time: [],
          toggleAbility: getUserToggleEnabled(true),
          about_us: "",
          gender: getGenderType(EnumGenderType.MALE),
        };
        let isApproved: boolean = item.approved === "no" ? false : true;
        const requestStatus: TempBranchRequestStatusModel = isApproved
          ? getTempBranchStatusElement(EnumTempBranchRequestStatus.ACCEPTED)
          : getTempBranchStatusElement(EnumTempBranchRequestStatus.PENDING);
        const prItem: TempBranchPendingRequestModel = {
          user: user,
          request_status: requestStatus,
        };
        array_requests.push(prItem);
      }
      callback(array_requests);
    } else {
      callback([]);
    }
  });
}

export function sendTeamLeadApprovalRequest(
  team_lead_id: string,
  employee_id: string,
  callback: (isSuccess: boolean, message: string) => void
) {
  let params = new FormData();
  params.append("team_lead_id", team_lead_id);
  params.append("employee_id", employee_id);
  params.append("auth_key", getAuthToken());
  const url: string = baseUrl + "/branches/approve_request";
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    const entry_id: string = responeObj.team_leader_id;

    const isSuccess: boolean = entry_id !== undefined;
    callback(isSuccess, item as string);
  });
}

/* ********************************** Employee **************************** */

export function fetchEmployeeSchedule(
  employee_id: string,
  callback: (array_schedules: EmployeeScheduleModel[]) => void
) {
  let params = new FormData();
  params.append("employee_id", employee_id);
  params.append("auth_key", getAuthToken());
  const url: string = baseUrl + "/shift_plan/employee/get";
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));

    //callback(isSuccess, item as string);
    const isArray: boolean = Array.isArray(responeObj);
    let array_schedules: EmployeeScheduleModel[] = [];
    if (isArray) {
      for (let i = 0; i < responeObj.length; i++) {
        const jsonItem = responeObj[i];
        const schedule_item: EmployeeScheduleModel = {
          plan_id: jsonItem.plan_id,
          plan_date: jsonItem.plan_date,
          employee_start_time: jsonItem.employee_start_time,
          employee_end_time: jsonItem.employee_end_time,
          team_lead_email: jsonItem.team_lead_email,
          branch_name: jsonItem.branch_name,
          branch_address: jsonItem.branch_address,
          shift_name: jsonItem.shift_name,
        };
        array_schedules.push(schedule_item);
      }
    }
    callback(array_schedules);
  });
}

export function fetchEmployeeHistory(
  employee_id: string,
  callback: (history: EmployeeHistoryModel | undefined) => void
) {
  let params = new FormData();
  params.append("employee_id", employee_id);
  params.append("auth_key", getAuthToken());
  const url: string = baseUrl + "/shift_plan/reports/employee";
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    //const entry_id: string = responeObj.id;
    //const isSuccess: boolean = entry_id !== undefined;

    const jsonArray = responeObj.shifts;
    const isArray: boolean = Array.isArray(jsonArray);

    let array_dailyLogs: EmployeeDailyLogModel[] = [];
    if (isArray) {
      for (let i = 0; i < jsonArray.length; i++) {
        const jsonItem = jsonArray[i];
        const log_entries = jsonItem.log_entries;
        let array_entries: ShiftEmployeeEntries[] = [];
        if (Array.isArray(log_entries)) {
          for (let j = 0; j < log_entries.length; j++) {
            const log_item = log_entries[j];
            const entry_item: ShiftEmployeeEntries = {
              user_id: responeObj.employee_id,
              shift_log_id: jsonItem.shift_log_id,
              start_time: log_item.employee_start_time,
              end_time: log_item.employee_end_time,
            };
            array_entries.push(entry_item);
          }
        }

        // const start_time: string = convertServerToTimePickerString(
        //   array_entries[0].start_time
        // );
        const start_time: string = array_entries[0].start_time;
        const end_time: string | undefined =
          array_entries[array_entries.length - 1].end_time;
        const hourly_rate: string = jsonItem.hourly_rate;
        const hr_rate: number = Number.parseFloat(hourly_rate);
        const workin_seconds: number =
          calculateTotalIntervalInSeconds(array_entries);
        const break_hrs: string = calculateEmployeeBreakTime(
          start_time,
          end_time,
          workin_seconds
        );
        const earning: string = calculateEmployeeEarning(
          workin_seconds,
          hr_rate
        ).toFixed(2);
        const daily_log_ele: EmployeeDailyLogModel = {
          shift_log_id: jsonItem.shift_log_id,
          shift_date: convertServerToRegularDate(jsonItem.shift_date),
          branch_name: jsonItem.branch_name,
          hourly_rate: jsonItem.hourly_rate,
          array_entries: array_entries,
          total_hours: calculateEmployeeElapsedTime(array_entries),
          break_hours: break_hrs,
          earning: earning,
        };
        array_dailyLogs.push(daily_log_ele);
      }
      const historyEle: EmployeeHistoryModel = {
        employee_id: responeObj.employee_id,
        first_name: responeObj.first_name,
        last_name: responeObj.last_name,
        email: responeObj.email,
        array_dailyLogs: array_dailyLogs,
      };

      callback(historyEle);
    } else {
      callback(undefined);
    }
  });
}

/* **************************** Forgot password ******************** */
export function fetchForgotPasswordCode(
  user_email_id: string,
  callback: (isSuccess: boolean) => void
) {
  let params = new FormData();
  params.append("email", user_email_id);
  const url: string = baseUrl + "/users/forgot_password/send_code";
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));

    //callback(isSuccess, item as string);
    callback(responeObj.password_reset_code !== undefined);
  });
}

export function fetchForgotPasswordValidateCode(
  user_email_id: string,
  validation_code: string,
  callback: (isSuccess: boolean) => void
) {
  let params = new FormData();
  params.append("email", user_email_id);
  params.append("password_reset_code", validation_code);
  const url: string = baseUrl + "/users/forgot_password/validate_code";
  postData(url, params, (item: any, status_code: number) => {
    const responeObj = JSON.parse(JSON.stringify(item));
    //callback(isSuccess, item as string);
    //const isSuccess: boolean = responeObj.success.toLowercase().match("yes");
    callback(status_code === 200);
  });
}

export function fetchForgotPasswordReset(
  user_email_id: string,
  password_reset_code: string,
  new_password: string,
  callback: (isSuccess: boolean) => void
) {
  let params = new FormData();
  params.append("email", user_email_id);
  params.append("password_reset_code", password_reset_code);
  params.append("new_password", new_password);
  const url: string = baseUrl + "/users/forgot_password/reset";
  postData(url, params, (item: any) => {
    const responeObj = JSON.parse(JSON.stringify(item));

    //callback(isSuccess, item as string);
    callback(true);
  });
}

/* ********************************** Misc *************************** */

export async function confirmPassword(
  user: UserModel,
  password: string,
  callback: (isSuccess: boolean) => void
) {
  //await timeout(1000);
  bcrypt.hash(
    password,
    getEncryptionKey(),
    (herr: Error | null, hash: string) => {
      if (herr === null) {
        if (hash === user.password) {
          callback(true);
        } else {
          callback(false);
        }
      }
    }
  );
}

export async function sendReportBM() {
  await timeout(1000);
  return true;
}

export async function delayCall(milliseconds: number, callback: () => void) {
  await timeout(milliseconds);
  callback();
}
